import template from './failed-orders-list.html';
export var failedOrdersListComponent = {
    template: template,
    bindings: {},
    controller: /** @class */ (function () {
        function failedOrdersListComponent(FailedOrdersService) {
            'ngInject';
            this.sortReverse = true;
            this.sortType = 'failedDate';
            this.failedOrdersService = FailedOrdersService;
        }
        failedOrdersListComponent.prototype.$onInit = function () {
            this.getFailedOrdersList();
        };
        failedOrdersListComponent.prototype.getFailedOrdersList = function () {
            var _this = this;
            this.loadingFailedOrders = true;
            this.failedOrdersService.getFailedOrders()
                .then(function (data) {
                if (data) {
                    _this.failedOrderDetails = data;
                    if (_this.failedOrderDetails.length > 0) {
                        _this.loadProcessedOrder = true;
                    }
                    else {
                        _this.loadUnprocessedOrder = true;
                    }
                }
                else {
                    _this.loadUnprocessedOrder = true;
                }
            })
                .finally(function () { return _this.loadingFailedOrders = false; });
        };
        return failedOrdersListComponent;
    }()),
};
//# sourceMappingURL=failed-orders-list.component.js.map